module.exports = __webpack_public_path__ + "images/missing_company.png";